<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<p class="h1" id="d7e1962557" style="color: #82a339"><b>SUMMERTIME CORN CHOWDER</b></p>
<p class="ext" id="d7e1963057"><b><i>A basket of warm Buttermilk Biscuits and thickly sliced ham are all that’s needed to complete the menu for a real summertime treat.</i></b></p>
<p class="h4" id="d7e1964357" style="color: #496210"><b>Prep: 25 minutes Cook: 35 to 40 minutes</b></p>
<p class="ul" id="d7e1964857">6 medium ears corn, husks and silk removed</p>
<p class="ul" id="d7e1965157">4 slices bacon, cut into ½-inch pieces</p>
<p class="ul" id="d7e1966257">1 medium red onion, chopped</p>
<p class="ul" id="d7e1966557">1 jalapeño chile, seeded and finely chopped</p>
<p class="ul" id="d7e1967257">1 garlic clove, finely chopped</p>
<p class="ul" id="d7e1967557">2 tablespoons all-purpose flour</p>
<p class="ul" id="d7e1967857">½ teaspoon salt</p>
<p class="ul" id="d7e1968757">⅛ teaspoon ground black pepper</p>
<p class="ul" id="d7e1969757">1 pound red potatoes (6 medium), cut into <br/> ½-inch pieces</p>
<p class="ul" id="d7e1971057">2 cans (14½ ounces each) chicken broth or <br/> 3½ cups Chicken Broth</p>
<p class="ul" id="d7e1973357">2 cups half-and-half or light cream</p>
<p class="ul" id="d7e1973657">2 small ripe tomatoes (8 ounces), peeled, <br/> seeded, and chopped <br/> thinly sliced basil leaves</p>
<p class="pub" id="d7e1974757" style="margin-top: 1.5em;"><span style="color: #c15b49"><b>1.</b></span> Cut kernels from corncobs (about 3 cups), reserving 3 corncobs; discard remaining corncobs.</p>
<p class="pub" id="d7e1975957"><span style="color: #c15b49"><b>2.</b></span> In 5-quart Dutch oven, cook bacon over medium heat until browned. With slotted spoon, transfer bacon to paper towels to drain; crumble.</p>
<p class="pub" id="d7e1977357"><span style="color: #c15b49"><b>3.</b></span> To bacon drippings in Dutch oven, add onion and jalapeño and cook, stirring, until onion is tender, about 5 minutes. Add garlic; cook 1 minute longer. Stir in flour, salt, and pepper; cook, stirring, 1 minute.</p>
<p class="pub" id="d7e1979557"><span style="color: #c15b49"><b>4.</b></span> Stir in potatoes, reserved corncobs, broth, and half-and-half; heat to boiling over high heat. Reduce heat; cover and simmer until potatoes are tender, 10 to 15 minutes.</p>
<p class="pub" id="d7e1981257"><span style="color: #c15b49"><b>5.</b></span> Discard corncobs; stir in reserved corn kernels and heat through. Transfer chowder to warm tureen. Stir in tomatoes and sprinkle with bacon and basil. Makes about 9½ cups or 8 first-course servings.</p>
<p class="ntx" id="d7e1984557">Each serving: About 272 calories, 7g protein, 29g carbohydrate, 15g total fat (7g saturated), 30mg cholesterol, 693mg sodium.</p>
<p class="ser"><img alt="9781618371621_0057_001" src="Images/9781618371621_0057_001.jpg" style="max-width:100%;"/></p>
<p class="cap" id="d7e1987657">Summertime Corn Chowder</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// West_9781618371621_epub_c55_r1.vue?0e6c57c1